import { gql } from 'graphql-request';

export default gql`mutation setVizuloManager($VizuloManagerInput: VizuloManagerInput!) {
    setVizuloManager(
        input: $VizuloManagerInput
    ) {
        status
    }
}`;